export const SET_PHONE_LANGUAGE = 'SET_PHONE_LANGUAGE';